import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'

createApp(App).mount('#app')